module.exports = __webpack_public_path__ + "static/images/containers/StrongholdExternal/components/Statistics/images/elo-icon-6.bf5b62b6.png";


//////////////////
// WEBPACK FOOTER
// ./containers/StrongholdExternal/components/Statistics/images/elo-icon-6.png
// module id = 3449
// module chunks = 11